/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Kind_MsiInputs */

const en_fc_dl_kind_msi = /** @type {(inputs: Fc_Dl_Kind_MsiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MSI installer`)
};

/**
* | output |
* | --- |
* | "MSI installer" |
*
* @param {Fc_Dl_Kind_MsiInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_kind_msi = /** @type {((inputs?: Fc_Dl_Kind_MsiInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Kind_MsiInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_kind_msi(inputs)
});
export { fc_dl_kind_msi as "fc.dl.kind.msi" }